<template>
  <div></div>
</template>

<script setup>
  import { watchEffect, ref } from 'vue'
  import { useVModel, useTimeoutFn } from '@vueuse/core'
  import { usePage } from '@inertiajs/vue3'
  import { ElNotification } from 'element-plus'
  import 'element-plus/dist/index.css'

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: true,
    },
  })

  // set modelValue default
  let modelValue = ref(true)

  // set data model emit for events
  const emit = defineEmits(['update:modelValue'])
  const data = useVModel(props, 'modelValue', emit)

  // Watch for flash messages and errors
  watchEffect(() => {
    const page = usePage()
    const flashSuccess = page.props.flash.success
    const flashError = page.props.flash.error
    const flashErrors = page.props.errors

    if (flashSuccess && data) {
      ElNotification({
        title: 'Success',
        message: flashSuccess,
        type: 'success',
        duration: 4500,
        position: 'top-right',
        customClass: 'notification-left-align',
        onClose: () => {
          modelValue.value = false
          emit('update:modelValue', false)
        },
      })
    }

    if (flashError && data) {
      ElNotification({
        title: 'Error',
        message: flashError,
        type: 'error',
        duration: 4500,
        position: 'top-right',
        customClass: 'notification-left-align',
        onClose: () => {
          modelValue.value = false
          emit('update:modelValue', false)
        },
      })
    } else if (Object.keys(flashErrors).length > 0 && data) {
      const errorCount = Object.keys(flashErrors).length
      const message =
        errorCount === 1 ? 'There is one form error.' : `There are ${errorCount} form errors.`

      ElNotification({
        title: 'Form Errors',
        message,
        type: 'error',
        duration: 4500,
        position: 'top-right',
        customClass: 'notification-left-align',
        onClose: () => {
          modelValue.value = false
          emit('update:modelValue', false)
        },
      })
    }

    // Set up auto-close timer
    if (flashErrors) {
      modelValue.value = true
      useTimeoutFn(() => {
        if (flashErrors) {
          modelValue.value = false
        }
      }, 4500)
    }
  })
</script>

<style>
  .notification-left-align .el-notification__content {
    text-align: left !important;
  }

  .notification-left-align .el-notification__title {
    text-align: left !important;
  }
</style>
